import React from 'react';

import Loader from '@/components/Loader';

import WideCard from '..';

const content = {};

interface Props {
  className?: string;
}

function WideCardLoader({ className }: Props) {
  return (
    <WideCard className={className} content={content}>
      <Loader showLabel={false} />
    </WideCard>
  );
}

export default WideCardLoader;
